import { render } from "./Creature.vue?vue&type=template&id=dea664e2&lang=true"
import script from "./Creature.vue?vue&type=script&lang=js"
export * from "./Creature.vue?vue&type=script&lang=js"
script.render = render

export default script